import Localize from 'react-intl-universal';

import { get } from 'lodash-es';

import Checkbox from '@mui/material/Checkbox';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import { isObject, isString } from '@common/helpers/helpers';

const MultipleCheckboxInput = ({
  field = {},
  options = [],
  form: { touched, errors } = {},
  accessors: { valueAccessor = 'id', textAccessor = 'value' } = {},
  required = false,
  disabled = false,
  helperText = '',
  ...props
}) => {
  const getValue = (option, propName) => {
    if (isString(option)) {
      return option;
    }
    if (isObject(option)) {
      if (propName === textAccessor) return option[textAccessor] ?? '';
      if (propName === valueAccessor) return option[valueAccessor] ?? '';
    }
    return '';
  };

  return (
    <>
      {props.label && (
        <InputLabel
          required={required}
          id={field?.name}
          disabled={disabled}
          error={Boolean(get(touched, field?.name) && get(errors, field?.name))}
        >
          {props.label}
        </InputLabel>
      )}
      <Select
        multiple
        size='small'
        labelId={field?.name}
        error={Boolean(get(touched, field?.name) && get(errors, field?.name))}
        disabled={disabled}
        renderValue={(selected = []) => {
          const items = options.filter((option) =>
            selected.find((s) =>
              isObject(s) ? s[valueAccessor] === option[valueAccessor] : s === option[valueAccessor]
            )
          );
          return items.map((option) => option[textAccessor]).join(', ');
        }}
        {...field}
        {...props}
        value={field.value.map((element) => (isObject(element) ? element[valueAccessor] : element))}
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={getValue(option, valueAccessor)} disabled={option?.disabled}>
            <Checkbox
              checked={Boolean(
                field.value.find((element) =>
                  isObject(element)
                    ? element[valueAccessor] === option[valueAccessor]
                    : element === option[valueAccessor]
                )
              )}
            />
            {getValue(option, textAccessor)}
          </MenuItem>
        ))}
      </Select>
      {get(touched, field?.name) && get(errors, field?.name) && (
        <FormHelperText error={true}>{get(errors, field?.name)}</FormHelperText>
      )}
      {helperText && (
        <FormHelperText id='component-helper-text'>{Localize.get(helperText)}</FormHelperText>
      )}
    </>
  );
};

export default MultipleCheckboxInput;
